import { render } from "./LoginFormComponent.vue?vue&type=template&id=6bd0543b&scoped=true"
import script from "./LoginFormComponent.vue?vue&type=script&lang=js"
export * from "./LoginFormComponent.vue?vue&type=script&lang=js"

import "./LoginFormComponent.vue?vue&type=style&index=0&id=6bd0543b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd0543b"]])

export default __exports__